import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './components/LoginPage';
import FeedbackForm from './components/FeedbackForm';
import './App.css';

function App() {
  return (
    <Router>
      <div className="global-top-strip">
        <img
          src="/assets/images/SLUDI-login-top-strip.png"
          alt="Sri Lankan Flag Colors"
          className="flag-image"
        />
      </div>
      <div className="background-overlay"></div>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/feedback" element={<FeedbackForm />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;